
const EventNotification = {
  UserUpdate: 'sh-user-update',
  VipApplyCancel: 'sh-vip-application-cancel',
  judgeApplicationSuccess: 'judge-application-success',
  updatePersonalCenterTabs: 'update-personal-center-tabs',
  updateCoachData: 'user-update-coach-data',
  coachApplicationSuccess: 'judge-application-success-flag',
};

let newListenEvent = function (name, callback) {
  return {
    name,
    callback
  };
};


let newListener = function () {
  return {
    flag: '',

    eventList: [

    ]
  }
};


export default {

  listen_list: [],
  notificationNameObject: EventNotification,

  register(flag, eventName, callback){
    if (flag == undefined || flag.length == 0) {
      return;
    }
    if (eventName == undefined || eventName.length == 0) {
      return;
    }
    if (callback == undefined || callback == null) {
      return;
    }

    if (this.listen_list.length == 0) {
      let listener = newListener();
      let listenEvent = newListenEvent(eventName, callback);
      listener.flag = flag;
      listener.eventList.push(listenEvent);
      this.listen_list.push(listener);
    } else {
      let tempListener = null;
      let listen_index = -1;
      for (let i = 0; i < this.listen_list.length; i++) {
        let listener = this.listen_list[i];
        if (listener.flag == flag) {
          tempListener = listener;
          listen_index = i;
          break;
        }
      }
      if (tempListener == null) {
        let listener = newListener();
        let listenEvent = newListenEvent(eventName, callback);
        listener.flag = flag;
        listener.eventList.push(listenEvent);
        this.listen_list.push(listener);
      } else {

        let tempListenEvent = null;
        let tempListEvent_index = -1;
        for (let i = 0; i < tempListener.eventList.length; i++) {
          let listenEvent = tempListener.eventList[i];
          if (listenEvent.name == eventName) {
            tempListenEvent = listenEvent;
            tempListEvent_index = i;
            break;
          }
        }

        if (tempListenEvent != null) {
          tempListenEvent.callback = callback;
        } else {
          let listenEvent = newListenEvent(eventName, callback);
          tempListener.eventList.push(listenEvent);
        }
      }
    }
  },
  unregister(flag, eventName) {
    if (flag == undefined || flag.length == 0) {
      return;
    }
    if (eventName == undefined || eventName.length == 0) {
      return;
    }
    if (this.listen_list.length == 0) {
      return;
    }

    let tempListener = null;
    let listener_index = -1;
    for (let i = 0; i < this.listen_list.length; i++) {
      let listener = this.listen_list[i];
      if (listener.flag == flag) {
        tempListener = listener;
        listener_index = i;
        break;
      }
    }

    if (tempListener != null) {
      for (let i = 0; i < tempListener.eventList.length; i++) {
        let listenEvent = tempListener.eventList[i];
        if (listenEvent.name == eventName) {
          tempListener.eventList.splice(i, 1);
          break;
        }
      }

      if (tempListener.eventList.length == 0) {
        this.listen_list.splice(listener_index, 1);
      }
    }
  },

  unregisterAllEvents(flag) {
    if (flag == undefined || flag.length == 0) {
      return;
    }

    if (this.listen_list.length == 0) {
      return;
    }

    for (let i = 0; i < this.listen_list.length; i++) {
      let listener = this.listen_list[i];
      if (listener.flag == flag) {
        this.listen_list.splice(i,1);
        break;
      }
    }
  },

  postNotification(eventName, data) {
    if (eventName == undefined || eventName.length == 0) {
      return;
    }
    if (this.listen_list.length == 0) {
      return;
    }

    for (let i = 0; i < this.listen_list.length; i++) {
      let listener = this.listen_list[i];
      for (let j = 0; j < listener.eventList.length; j++) {
        let listenEvent = listener.eventList[j];
        if (listenEvent.name == eventName) {
          if (data != undefined) {
            listenEvent.callback(data);
          } else {
            listenEvent.callback();
          }
        }
      }
    }
  }
}




// WEBPACK FOOTER //
// ./src/js/event-common.js